module.exports = __webpack_public_path__ + "img/New-Caledonia.4d214a9f.png";